import React from 'react';
import PropTypes from 'prop-types';
import FormButton from '../../../../../vendor/react-validation/components/button';


export default class MetaList extends React.Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node,
            PropTypes.array
        ]),
        actionShow: PropTypes.bool,
        actionLabel: PropTypes.string,
        actionOnClick: PropTypes.func,
        actionIsFormButton: PropTypes.bool,
        
        secondaryActionShow: PropTypes.bool,
        secondaryActionLabel: PropTypes.string,
        secondaryActionOnClick: PropTypes.func,

        push: PropTypes.bool,
        border: PropTypes.bool,

        modifierClass: PropTypes.array
    }

    static defaultProps = {
        children: [],
        excerpt: '',
        modifierClass: [],
        actionShow: false,
        actionLabel: '',
        actionOnClick: () => {},
        push: false,
        border: true,
        actionIsFormButton: false,
        secondaryActionShow: false,
        secondaryActionLabel: '',
        secondaryActionOnClick: () => {}
    };

    onActionClick() {
        this.props.actionOnClick();
    }
    secondaryActionClick() {
        this.props.secondaryActionOnClick();
    }

    render() {
        const classNames = ['meta-list'].concat(this.props.modifierClass);
        let actionButton;
        let secondaryActionButton;

        if(this.props.push) {
            classNames.push('meta-list--push')
        }
        if(!this.props.border) {
            classNames.push('meta-list--no-border')
        }

        if (this.props.actionShow) {
            actionButton = (
                <button
                    className="meta-list__actions__action my-pages-btn button button--green"
                    onClick={(ev) => {  ev.preventDefault(); this.onActionClick(); }}
                >
                    {this.props.actionLabel}
                </button>
            );

            if (this.props.actionIsFormButton) {
                actionButton = (<FormButton className="meta-list__actions__action meta-list__actions__action--form my-pages-btn button button--green">{this.props.actionLabel}</FormButton>);
            }
        }
        if (this.props.secondaryActionShow) {
            secondaryActionButton = (
                <button
                    className="meta-list__actions__action meta-list__actions__action--secondary my-pages-btn button button--green"
                    onClick={(ev) => {  ev.preventDefault(); this.secondaryActionClick(); }}
                >
                    {this.props.secondaryActionLabel}
                </button>
            );
        }


        return (
            <div className={classNames.join(' ')}>
                <dl className="meta-list__list">
                    {this.props.children}
                </dl>
                {(this.props.actionShow || this.props.secondaryActionShow) && (
                <div className="meta-list__actions">
                    {actionButton}
                    {secondaryActionButton}
                </div>
                )}
            </div>
        );
    }
};

